module.exports = __webpack_public_path__ + "img/pay-value2.f73e207f.png";